import { Sd3TextToImageOptionsSchema, Sd3ImageToImageOptionsSchema } from '~/services/inference/image-generation';
const STABILITY_API_BASE = 'https://api.stability.ai/v2beta/stable-image/generate/sd3';

export const sd3Generate = async ({ authorization, model, ...data }: Record<string, any>, image?: File) => {
  const formData = new FormData();
  const mode = image ? 'image-to-image' : 'text-to-image';

  const options = { authorization, ...data };

  if (image) {
    const validationResult = Sd3ImageToImageOptionsSchema.safeParse(options);
    if (!validationResult.success) {
      throw new Error(
        `SD3 pre-request API validation failed: ${validationResult.error.issues.map((issue) => issue.message).join(', ')}`,
      );
    }

    formData.append('image', image);
    formData.append('mode', 'image-to-image');
  } else {
    const validationResult = Sd3TextToImageOptionsSchema.safeParse(options);
    if (!validationResult.success) {
      throw new Error(
        `SD3 pre-request API validation failed: ${validationResult.error.issues.map((issue) => issue.message).join(', ')}`,
      );
    }
    formData.append('mode', 'text-to-image');
  }

  if (model) formData.append('model', model);

  for (const k in data) {
    if (k === 'mode' || !data[k] || Number.isNaN(data[k])) continue;
    // @TODO: (IW) get rid of defaults/unexpected fields before they get this far
    if (model === 'sd3-turbo' && ['negative_prompt'].includes(k)) continue;
    if (mode === 'text-to-image' && ['strength'].includes(k)) continue;
    if (mode === 'image-to-image' && ['aspect_ratio'].includes(k)) continue;

    formData.append(k, String(data[k]));
  }

  const response = await fetch(STABILITY_API_BASE, {
    method: 'POST',
    headers: {
      Accept: 'image/*',
      Authorization: `Bearer ${authorization}`,
    },
    body: formData,
  });

  return response;
};
